
























































import { Component, Vue } from 'vue-property-decorator';
import AddBankAccount from './modals/addBankAccount.vue';

   @Component({
      components:{AddBankAccount}
    })

export default class BankAccounts extends Vue{

  isOpenModal:boolean=false;
  mockData:any[]=[];
  headers:any[]=[];
  breadcrumbsItems:any[]=[];


    created(){
      this.headers= [
          { text: 'Şube Adı',  align: 'start',filterable: false,   value: 'branchName', },
          { text: 'Şube Kodu', value: 'branchCode' },
          { text: 'Hesap Numarası', value: 'accountNo' },
          { text: 'Banka IBAN Numarası', value: 'iban' },
          { text: 'Şehir', value: 'city' },
          { text: "Banka Adı", value: "bankName" },
          { text: "İşlemler", value: "transactions" }

        ],
        this.mockData=[
          {
            branchName: 'Lara',
            branchCode: '1234	',
            accountNo: '567432',
            iban: 'TR45 3338 0002 8976 7896 5610 65',
            city:'Antalya',
            bankName:'Garanti',
          },

        ]

        this.breadcrumbsItems= [
          {text: 'Ana Sayfa',disabled: false,href: '/#/main/home'},
          {text: 'Finans',disabled: true},
          {text: 'Banka Hesapları',disabled: true}
        
      ]

    }

    data () {
      return {
        page: 1,
      }

    }
    
    openModal(){
      this.isOpenModal=true;
    }
    closeModal(){
       this.isOpenModal = false;
    }
    
}




